import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import cs from './cs.json';

// Initialize i18next with Czech locale
i18n
  .use(initReactI18next)
  .init({
    resources: {
      cs: {
        translation: cs,
      },
    },
    lng: 'cs', // Default language
    fallbackLng: 'cs',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
